import { render } from "./changePass.vue?vue&type=template&id=76e3115a&scoped=true"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"

import "./changePass.vue?vue&type=style&index=0&id=76e3115a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e3115a"]])

export default __exports__